window.mx = window.mx || {};

window.mx.MxFeaturedProduct = class extends window.mx.MxSection {
  constructor() {
    super();

    this.cachedProductData = null;
  }

  connectedCallback() {}

  get productData() {
    if (this.cachedProductData === null) {
      const sectionId = this.section.id;
      this.cachedProductData = JSON.parse(this.querySelector(`#${sectionId}__product-data`).textContent);
    }
    return this.cachedProductData;
  }
};
if (!window.customElements.get('mx-featured-product'))
  window.customElements.define('mx-featured-product', window.mx.MxFeaturedProduct);

window.mx.MxVariantPicker = class extends window.mx.MxComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.selectList.forEach(
      (select) => this.eventManager.addListener(select, 'change', (event) => this.onVariantChange(event)),
      'change',
    );
  }

  get selectList() {
    return this.querySelectorAll('select');
  }
  get addToCartContainer() {
    return this.section.querySelector('.block-container--add-to-cart');
  }
  get productData() {
    return this.section.querySelector('.mx-featured-product').productData;
  }
  get optionHandle() {
    const classicProduct = this.productData.classic_product;

    const optionHandle = Array.from(this.selectList)
      .map((select) => select.value)
      .join('');

    if (!classicProduct) {
      const purchaseMethod = this.productData.purchase_method;
      return `${purchaseMethod}-${optionHandle}`;
    }

    return optionHandle;
  }
  get variant() {
    return this.getVariantFromOptionHandle(this.optionHandle);
  }

  onVariantChange() {
    const purchaseMethod = this.productData.purchase_method;
    let newVariant = this.variant;

    if (purchaseMethod === 'reservation' && newVariant.available === false) {
      const newOptionHandle = newVariant.option_handle.replace('reservation', 'stock');
      newVariant = this.getVariantFromOptionHandle(newOptionHandle);
    }

    this.productData.current_variant = newVariant.id;

    newVariant.available
      ? this.addToCartContainer.setAttribute('data-variant-status', 'available')
      : this.addToCartContainer.setAttribute('data-variant-status', 'out-of-stock');

    this.updateStockInfo(newVariant.available);
  }

  updateStockInfo(available) {
    const stockInfo = this.section.querySelector('.purchase-info--stock');
    if (!stockInfo) return;

    const dot = stockInfo.querySelector('.purchase-info__dot');
    const label = stockInfo.querySelector('[data-stock-label]');
    const delivery = stockInfo.querySelector('[data-stock-delivery]');
    if (!dot || !label || !delivery) return;

    if (available) {
      dot.classList.remove('purchase-info__dot--out-of-stock');
      label.textContent = stockInfo.dataset.stockText + ',';
      delivery.textContent = stockInfo.dataset.deliveryText + '.';
    } else {
      dot.classList.add('purchase-info__dot--out-of-stock');
      label.textContent = stockInfo.dataset.outOfStockText + ',';
      delivery.textContent = stockInfo.dataset.createAlertText;
    }
  }

  getVariantFromOptionHandle(handle) {
    return Object.values(this.productData.variants).find((variant) => variant.option_handle === handle);
  }
};
if (!window.customElements.get('mx-variant-picker'))
  window.customElements.define('mx-variant-picker', window.mx.MxVariantPicker);

window.mx.MxAddToCart = class extends window.mx.MxComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.eventManager.addListener(this, 'click', () => this.onClick());
  }

  get productData() {
    return this.section.querySelector('.mx-featured-product').productData;
  }

  async onClick() {
    try {
      this.setAttribute('disabled', '');

      const cartSectionId = document.querySelector('.shopify-section-cart-drawer').id.split('shopify-section-').pop();

      const giftCardInfos = document.querySelector('.gift-card-recipient-form');

      // Parse gift card recipient form inputs
      const giftCardCheckbox = document.querySelector('#gift-card-recipient-checkbox');
      const isGiftCardRecipient = giftCardCheckbox?.checked ?? false;

      const recipientEmail = giftCardInfos?.querySelector('#gift-card-recipient-email')?.value || '';
      const recipientName = giftCardInfos?.querySelector('#gift-card-recipient-name')?.value || '';
      const recipientMessage = giftCardInfos?.querySelector('#gift-card-recipient-message')?.value || '';
      const sendOnDate = giftCardInfos?.querySelector('#gift-card-recipient-date')?.value || '';

      const { current_variant, purchase_method, reservation_campaign, country, fabric } = this.productData;

      const addToCartBody = {
        items: [
          {
            id: current_variant,
            quantity: 1,
            properties: {
              _purchase_method: purchase_method,
              _reservation_campaign: reservation_campaign,
              _country: country,
              _fabric: fabric,
              ...(isGiftCardRecipient && {
                __shopify_send_gift_card_to_recipient: true,
                'Recipient email': recipientEmail,
                'Recipient name': recipientName,
                'Message': recipientMessage,
                'Send on': sendOnDate,
              }),
            },
          },
        ],
        sections: [cartSectionId],
      };

      console.log(addToCartBody);

      const addToCartJson = await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(addToCartBody),
      }).then((response) => response.json());

      console.log(addToCartJson);

      refreshCartUserInterface(addToCartJson.sections[cartSectionId]);
      openCartDrawerHandler();
    } catch (error) {
      console.error('Error adding to cart', error);
    } finally {
      this.removeAttribute('disabled', '');
      window.mx.hideGorgiasButton();
    }
  }
};
if (!window.customElements.get('mx-add-to-cart')) window.customElements.define('mx-add-to-cart', window.mx.MxAddToCart);

window.mx.MxBackInStock = class extends window.mx.MxComponent {
  constructor() {
    super();
  }

  connectedCallback() {
    this.eventManager.addListener(this, 'click', () => this.onClick());
  }

  get productData() {
    return this.section.querySelector('.mx-featured-product').productData;
  }

  onClick() {
    const variantDataJson = this.productData['back_in_stock'];

    if (!BIS) {
      console.error('Back In Stock not loaded');
      return false;
    }

    BIS.Config.product = variantDataJson;

    BIS.popup = BIS.createPopover();
    BIS.popup?.toggle();
    BIS.popup?.form?.frame?.contentDocument?.querySelector('.action-close')?.style?.setProperty('display', 'block');
    BIS.popup?.form?.frame?.contentDocument?.querySelector('#variants')?.querySelectorAll('option')?.forEach((option) => {
      if (option.textContent.startsWith('Réservation')) {
        option.remove();
      }
    });
  }
};
if (!window.customElements.get('mx-back-in-stock'))
  window.customElements.define('mx-back-in-stock', window.mx.MxBackInStock);


window.mx.MxStickyAddToCart = class extends window.mx.MxComponent {
  constructor() {
    super();
    if (window.mx.MxStickyAddToCart.instance) {
      return window.mx.MxStickyAddToCart.instance;
    }
    window.mx.MxStickyAddToCart.instance = this;
    this.originalButtonContainer = document.querySelector('.block-container--add-to-cart');
  }

  connectedCallback() {
    this.footer = document.querySelector('#MainContent + *');
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.onScroll();

    const scrollToTopButton = document.querySelector('.mx-scroll-to-top');
    if (scrollToTopButton) {
      scrollToTopButton.classList.add('with-scroll-to-top');
    }
  }

  onScroll() {
    const scrolledEnough = window.scrollY >= window.innerHeight * 2 / 3;
    const footerVisible = this.footer && this.footer.getBoundingClientRect().top < window.innerHeight;
    this.setAttribute('data-visible', scrolledEnough && !footerVisible ? 'yes' : 'no');

    if (this.originalButtonContainer) {
      const variantStatus = this.originalButtonContainer.getAttribute('data-variant-status');
      if (variantStatus) {
        this.setAttribute('data-variant-status', variantStatus);
      }
    }
  }
};



if (!window.customElements.get('mx-sticky-add-to-cart')) {
  window.customElements.define('mx-sticky-add-to-cart', window.mx.MxStickyAddToCart);
}

// Tabs navigation
(function () {
  document.querySelectorAll('.block-container--tabs').forEach(function (container) {
    var buttons = container.querySelectorAll('[role="tab"]');
    var panels = container.querySelectorAll('[role="tabpanel"]');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var index = btn.dataset.tabIndex;

        buttons.forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        panels.forEach(function (p) {
          p.hidden = true;
        });

        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = container.querySelector('#tab-panel-' + index);
        if (panel) {
          panel.hidden = false;
        }
      });
    });
  });
})();

window.mx.MxPurchaseCountdown = class extends window.mx.MxComponent {
  connectedCallback() {
    const container = this.closest('[data-end-date]');
    if (!container) return;

    this.endDate = new Date(container.dataset.endDate);
    if (isNaN(this.endDate)) return;

    this.textEl = this.querySelector('.purchase-info__text');
    if (!this.textEl) return;

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  update() {
    const now = new Date();
    const diff = this.endDate - now;

    if (diff <= 0) {
      this.closest('.purchase-info__row--timer')?.remove();
      clearInterval(this.interval);
      return;
    }

    const days = Math.floor(diff / 86400000);
    const hours = Math.floor((diff % 86400000) / 3600000);
    const minutes = Math.floor((diff % 3600000) / 60000);

    this.textEl.innerHTML = `Plus que <strong>${days}j, ${hours}h et ${minutes}min</strong> pour le réserver`;
  }

  disconnectedCallback() {
    clearInterval(this.interval);
    super.disconnectedCallback();
  }
};
if (!window.customElements.get('mx-purchase-countdown')) {
  window.customElements.define('mx-purchase-countdown', window.mx.MxPurchaseCountdown);
}

window.mx.MxReassuranceSlider = class extends window.mx.MxComponent {
  connectedCallback() {
    this.track = this.querySelector('.reassurance-slider__track');
    this.slides = this.querySelectorAll('.reassurance-slider__slide');
    this.dotsContainer = this.querySelector('.reassurance-slider__dots');
    this.currentIndex = 0;
    this.total = this.slides.length;

    if (this.total <= 1) {
      if (this.dotsContainer) this.dotsContainer.remove();
      return;
    }

    this.buildDots();
    this.startAutoPlay();

    this.addEventListener('mouseenter', () => this.stopAutoPlay());
    this.addEventListener('mouseleave', () => this.startAutoPlay());
  }

  buildDots() {
    for (let i = 0; i < this.total; i++) {
      const dot = document.createElement('button');
      dot.className = 'reassurance-slider__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', `Slide ${i + 1}`);
      dot.addEventListener('click', () => this.goTo(i));
      this.dotsContainer.appendChild(dot);
    }
    this.dots = this.dotsContainer.querySelectorAll('.reassurance-slider__dot');
  }

  goTo(index) {
    this.currentIndex = index;
    this.track.style.transform = `translateX(-${index * 100}%)`;
    this.dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
    this.resetAutoPlay();
  }

  resetAutoPlay() {
    clearInterval(this.interval);
    this.interval = setInterval(() => this.next(), 4000);
  }

  next() {
    this.goTo((this.currentIndex + 1) % this.total);
  }

  startAutoPlay() {
    clearInterval(this.interval);
    this.interval = setInterval(() => this.next(), 4000);
  }

  stopAutoPlay() {
    clearInterval(this.interval);
  }

  disconnectedCallback() {
    this.stopAutoPlay();
    super.disconnectedCallback();
  }
};
if (!window.customElements.get('mx-reassurance-slider')) {
  window.customElements.define('mx-reassurance-slider', window.mx.MxReassuranceSlider);
}
